import { VariableType } from 'json-to-graphql-query';
export const MailTemplateInputVariables = {
    mailTemplate: 'MailTemplateInput!'
};
export const MailTemplateInputArgs = {
    mailTemplate: new VariableType('mailTemplate')
};
//# sourceMappingURL=mailTemplateInput.js.map